import { dataCustomerSettings } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCustomerSettings = /*#__PURE__*/createIcon(dataCustomerSettings)
export default IconCustomerSettings
